export enum ToastTheme {
  success = 'success',
  failure = 'failure',
  info = 'info',
  warning = 'warning',
}
